export default __webpack_public_path__ + "3.82.0/assets/7042e004b0dc95b68030990ac4fde804.png";